import { gql } from 'apollo-boost';

export const SEND_EMAIL_CAMPAIGN = gql`
    mutation($data: SendEmailCampaignInput!) {
        sendEmailCampaign(data: $data) {
            ... on SendEmailCampaignSuccess {
                success
                emailsSent
                totalVerifiedUsers
                campaignId
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;

